import SolrService from "./services/solrService";

angular.module('cfn').service('fieldSearchService', fieldSearchService);
fieldSearchService.$inject = ['$rootScope', '$log', '$q', '$http', '$sce', '$timeout'];

function fieldSearchService($rootScope, $log, $q, $http, $sce, $timeout) {
  const FIELD_BASE_URL = '/365FarmNet/rest/core/field/ActiveOnly';
  const FIELDGROUP_BASE_URL = '/365FarmNet/rest/core/fieldgroup/ActiveOnly';
  const START_PAGE = 0;
  const DEFAULT_ROWS = 500;

  let fieldSearchService = {
    searchActiveFields: searchActiveFields,
    searchActiveFieldGroups: searchActiveFieldGroups
  };

  return fieldSearchService;


  // --- public methods --------------------------------------------------------------------------
  /**
   * search the catalog field service
   * @param year
   * @param search
   * @returns {*}
   */
  function searchActiveFields(year) {
    return $http.get($sce.trustAsResourceUrl(FIELD_BASE_URL + '?param=' + year)).then(
      (response) => {
        if(response.data) {
          response.data.forEach((field) => {
            field.isGroup = false;
            field._objectType = 'field';
          });
          return response.data;
        } else {
          return [];
        }
      },
      (errorResponse) => {
        $log.error('Error getting active fields for user from backend: ', errorResponse);
        return [];
      }
    );
  };

  /**
   * search the catalog fieldgroup service
   * @param year
   * @param search
   * @returns {*}
   */
  function searchActiveFieldGroups(year) {
    return $http.get($sce.trustAsResourceUrl(FIELDGROUP_BASE_URL + '?param=' + year)).then(
      (response) => {
        if(response.data) {
          response.data.forEach((field) => {
            field.isGroup = true;
            field._objectType = 'fieldgroup';
          });
          return response.data;
        } else {
          return [];
        }
      },
      (errorResponse) => {
        $log.error('Error getting active field groups for user from backend: ', errorResponse);
        return [];
      }
    );
  };
};

export default fieldSearchService;
